import { render, staticRenderFns } from "./ScriptGroupSidebarForm.vue?vue&type=template&id=0d7108ac"
import script from "./ScriptGroupSidebarForm.vue?vue&type=script&lang=js"
export * from "./ScriptGroupSidebarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports